import { render } from "./TheMainContent.vue?vue&type=template&id=5d183b82"
import script from "./TheMainContent.vue?vue&type=script&lang=ts"
export * from "./TheMainContent.vue?vue&type=script&lang=ts"

import "./TheMainContent.vue?vue&type=style&index=0&id=5d183b82&lang=css"
script.render = render

export default script